import { Component, OnInit, ViewChild, Output, EventEmitter, ElementRef, NgZone, HostListener } from '@angular/core';
import { ModalDirective } from "ngx-bootstrap/modal";
import { GridOptions } from "ag-grid/main";
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Globals } from 'app/globals';
import { AssessmentsService } from 'app/services/assessment/AssessmentsService';
import { AdminService, AssessmentPurchaseDto, AssessmentPurchaseDetails } from 'app/services/admin/AdminService';
import { isUndefined } from 'util';
// import { forEach } from '@angular/router/src/utils/collection';
import { CoachService } from 'app/services/coach/CoachService';
import { CryptoJs } from 'app/shared/crypto-js/crypto-js.component';
declare var jquery: any;
declare var $: any;
import * as creditcardvalidator from 'jquery-creditcardvalidator/jquery.creditCardValidator';
import { ClientsService } from '../services/client/ClientsService';

@Component({
  selector: 'app-purchase-assessment-modal',
  templateUrl: './purchase-assessment-modal.component.html',
  styleUrls: ['./purchase-assessment-modal.component.scss']
})
export class PurchaseAssessmentModalComponent implements OnInit {

    @HostListener('keydown', ['$event'])
    onKeyDown(e: any) {
        if (e.target.inputMode == 'numeric') {
            if (
                // Allow: Delete, Backspace, Tab, Escape, Enter
                [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
                (e.keyCode === 65 && e.ctrlKey === true) || // Allow: Ctrl+A
                (e.keyCode === 67 && e.ctrlKey === true) || // Allow: Ctrl+C
                (e.keyCode === 86 && e.ctrlKey === true) || // Allow: Ctrl+V
                (e.keyCode === 88 && e.ctrlKey === true) || // Allow: Ctrl+X
                (e.keyCode === 65 && e.metaKey === true) || // Cmd+A (Mac)
                (e.keyCode === 67 && e.metaKey === true) || // Cmd+C (Mac)
                (e.keyCode === 86 && e.metaKey === true) || // Cmd+V (Mac)
                (e.keyCode === 88 && e.metaKey === true) || // Cmd+X (Mac)
                (e.keyCode >= 35 && e.keyCode <= 40) // Home, End, Left, Right
            ) {
                return;  // let it happen, don't do anything
            }
            // Ensure that it is a number and stop the keypress
            if (
                (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
                (e.keyCode < 96 || e.keyCode > 105)
            ) {
                e.preventDefault();
            }
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: any) {
        if (event.target.inputMode == 'numeric') {
            event.preventDefault();
            const pastedInput: string = event.clipboardData
                .getData('text/plain')
                .replace(/\D/g, ''); // get a digit-only string
            document.execCommand('insertText', false, pastedInput);
        }
    }
    @HostListener('drop', ['$event'])
    onDrop(event: any) {
        if (event.target.inputMode == 'numeric') {
            event.preventDefault();
            const textData = event.dataTransfer
                .getData('text').replace(/\D/g, '');
            //this.inputElement.focus();
            document.execCommand('insertText', false, textData);
        }
    }
    
    @ViewChild('purchaseAssessment', {static: true}) public modal: ModalDirective;
    @ViewChild('modalContent', {static: true}) modalContent: ElementRef;

    purchaseAssessments: boolean = true;
    askingQuestions: boolean = false;
    questionIndex: number = 0;
    finishPurchase: boolean = false;

    niches: any[] = []
    assessments: any[] = [];
    assessmentsTypes: any[] = [];
    nicheDefault: number = 1;
    currentNicheOrDefault: string = "General";
    currentTypeOrDefault: string = "Regular";
    total: number = 0;

    orders: any[] = [];
    ordersHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;
    height: number;
    count: number;

    assessmentDetails: AssessmentPurchaseDetails[] = [];

    parent: any;

    selectedCreditCard = {
        cardNumber: "", //5555555555554444
        cardUserName: "",
        cardType: "",
        expiryMonth: "",
        expiryYear: "",
        cvc: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zipCode: "",
        country: "United States",
        phone: "",
        email: ""
    }

    message: string;
    showATCombo: boolean = false; //show assessment type combo
    pricings: any[] = [];
    selectedAssessmentIndex = 0;
    eliAssessment: any[] = [];
    assessment360: any[] = [];
    coachCreaditCards: any[] = [];

    addingNewCreditCard: boolean = false;
    year = new Date().getFullYear();

    newCreditCard = {
        number: "",
        name: "",
        type: "",
        month: "1",
        year: `${this.year}`,
        cvc: ""
    }

    validCreditCard: boolean = false;
    selectedCreditCardId: string = "";
    emptyFields: any[] = [];

    countryList: string[] = [
        "Afghanistan",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas (the)",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia (Plurinational State of)",
        "Bonaire, Sint Eustatius and Saba",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "British Indian Ocean Territory (the)",
        "Brunei Darussalam",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cabo Verde",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cayman Islands (the)",
        "Central African Republic (the)",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands (the)",
        "Colombia",
        "Comoros (the)",
        "Congo (the Democratic Republic of the)",
        "Congo (the)",
        "Cook Islands (the)",
        "Costa Rica",
        "Croatia",
        "Cuba",
        "Curacao",
        "Cyprus",
        "Czechia",
        "Cote d'Ivoire",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic (the)",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Eswatini",
        "Ethiopia",
        "Falkland Islands (the) [Malvinas]",
        "Faroe Islands (the)",
        "Fiji",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "French Southern Territories (the)",
        "Gabon",
        "Gambia (the)",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Heard Island and McDonald Islands",
        "Holy See (the)",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran (Islamic Republic of)",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Korea (the Democratic People's Republic of)",
        "Korea (the Republic of)",
        "Kuwait",
        "Kyrgyzstan",
        "Lao People's Democratic Republic (the)",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macao",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands (the)",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia (Federated States of)",
        "Moldova (the Republic of)",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands (the)",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger (the)",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "Northern Mariana Islands (the)",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestine, State of",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines (the)",
        "Pitcairn",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Republic of North Macedonia",
        "Romania",
        "Russian Federation (the)",
        "Rwanda",
        "Reunion",
        "Saint Barthelemy",
        "Saint Helena, Ascension and Tristan da Cunha",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Martin (French part)",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Sint Maarten (Dutch part)",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Georgia and the South Sandwich Islands",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan (the)",
        "Suriname",
        "Svalbard and Jan Mayen",
        "Sweden",
        "Switzerland",
        "Syrian Arab Republic",
        "Taiwan (Province of China)",
        "Tajikistan",
        "Tanzania, United Republic of",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks and Caicos Islands (the)",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates (the)",
        "United Kingdom of Great Britain and Northern Ireland (the)",
        "United States Minor Outlying Islands (the)",
        "United States",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela (Bolivarian Republic of)",
        "Viet Nam",
        "Virgin Islands (British)",
        "Virgin Islands (U.S.)",
        "Wallis and Futuna",
        "Western Sahara",
        "Yemen",
        "Zambia",
        "Zimbabwe",
        "Aland Islands"
    ];
    currentEnteredCvv = "";
    loading = false;
    discounts = [];
    totalDiscount = 0;

    constructor(
        private _AdminService: AdminService,
        private _CoachService: CoachService,
        private _ClientService: ClientsService,
        private _AssessmentsService: AssessmentsService,
        private toastr: ToastrService,
        private router: Router,
        private _Globals: Globals,
        private _CryptoJs: CryptoJs
    ) {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
    }

    ngOnInit() {
        //this.getNiches();
        //this.getAssessmentTypes();
        //this.getAssessmentsByNiche(this.nicheDefault);

        this.getAssessmentsbyType(false);

        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.ordersHeaders = this.createHeaders();
        this.getAssessmentsbyType(true);
    }

    getAssessmentTypes() {
        this._AssessmentsService.getAssessmentTypes().subscribe((data: any) => {
            console.log('getAssessmentTypes', data.result);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.assessmentsTypes = _data;
                console.log(_data);
                //this.loading = false;
            }
        })
    }

    getNiches() {
        this._AdminService.getNiches().subscribe((data: any) => {
            let result = data.result.Result;

            console.log('Get Niches', data);
            if (result <= -10) {
                //this.toastr.warning('Expired token please login again.', 'ELI');
                this.router.navigate(['/login']);
                this._Globals.deleteAllStorage();
                return;
            }

            let _data = JSON.parse(data.result.Data);
            this.niches = _data;
        });
    }

    resetQuantity() {
        $('#quantity').val(1);
        $('#quantity360').val(1);
    }

    changePricingIndex() {
        let index = $("#purchaseAssessmentSelect").prop('selectedIndex');
        this.selectedAssessmentIndex = index;

        this.resetQuantity();
    }

    getAssessmentsbyType(is360) {

        this.resetQuantity();

        if (is360 == 1) {
            is360 = false
        } else {
            is360 = true
        }

        //this.loading = true;
        this._AssessmentsService.getAssessmentsByType(is360).subscribe((data: any) => {
            console.log('getAssessmentsByType');

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('getAssessmentsByType_response', _data);
                //this.assessments = _data;
                //this.pricings = this.assessments;
                //console.log(this.pricings);
                //this.selectedAssessmentIndex = 0;
                //this.loading = false;

                if (!is360) {
                    this.eliAssessment = _data;
                    console.log(this.eliAssessment);
                } else {
                    this.assessment360 = _data;
                    console.log(this.assessment360);
                }
            }
        });
    }

    validateData() {
        //console.log(this.selectedCreditCard);
        let isValid = true;
        this.emptyFields = [];

        if (this.selectedCreditCard.address1 == '') {
            this.emptyFields.push('Address Line 1');
            isValid = false;
        }

        if (this.selectedCreditCard.city == '') {
            this.emptyFields.push('City');
            isValid = false;
        }

        if (this.selectedCreditCard.zipCode == '') {
            this.emptyFields.push('Zip Code');
            isValid = false;
        }

        //if (this.selectedCreditCard.phone == '') {
        //    this.emptyFields.push('Phone Number');
        //    isValid = false;
        //}

        //if (this.selectedCreditCard.email == '') {
        //    this.emptyFields.push('Email Address');
        //    isValid = false;
        //}

        return isValid;
    }

    validateEmail(email: string): boolean {
        console.log("email", email);

        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let validEmail = regex.test(email);
        console.log('Valid', validEmail)
        if (validEmail) return true;
        else {
            this.toastr.warning('Please enter a valid email address', "ELI");
            return false;
        }
    }

    purchaseProcess() {
        if (this.coachCreaditCards.length == 0) {
            this.toastr.warning('No credit cards on file. Please use the Add Credit Card button to enter your credit card information.', 'ELI');
            return;
        }

        if (this.selectedCreditCardId == '' || this.selectedCreditCard.cardUserName == '' || this.selectedCreditCard.cvc == '' || this.selectedCreditCard.cvc == undefined) {
            this.toastr.warning('Please enter the CVV code.', 'ELI');
            return;
        }

        if (!this.validateData()) {
            let fields = this.emptyFields.join();
            this.toastr.warning('Please enter the following fields for the billing address: ' + fields.replace(/,/g, ', '), 'ELI');
            return;
        }

        //if (!this.validateEmail(this.selectedCreditCard.email)) {
        //    return;
        //}        

        $('body').css('cursor', 'wait');
        this.loading = true;
        this.addBillingAddress();

    }

    addBillingAddress() {

        let data = {
            "CardId": this.selectedCreditCardId,
            "BillAddress1": this.selectedCreditCard.address1,
            "BillAddress2": this.selectedCreditCard.address2,
            "BillCity": this.selectedCreditCard.city,
            "BillState": this.selectedCreditCard.state,
            "BillZip": this.selectedCreditCard.zipCode,
            "BillCountry": this.selectedCreditCard.country,
            "BillPhoneNumber": this.selectedCreditCard.phone,
            "BillEmail": this.selectedCreditCard.email,
            "CVV": this.selectedCreditCard.cvc
        }

        this._CoachService.postAddBillingAddress(this._CryptoJs.encrypt(JSON.stringify(data), '3s6v9y$8&3)H@McQfT8KnZqWt7w!A%Y*')).subscribe((data: any) => {
            console.log(`response postAddBillingAddress`, data);
            if (this._Globals.validationToken(data.result.Result)) {
                console.log(data.result.Result);

                if (data.result.Result == 1) {
                    this.saveAssessmentPurchase();
                } else {
                    console.log('error');
                    this.toastr.error('We are sorry.  An error happened while trying to verify the credit card billing address.  Please check it out and try again', 'ELI');
                    this.loading = false;
                }
            } 
        });
    }

    randomNum():number {
        return Math.floor((Math.random() * 8999) + 1000);
    }

    saveAssessmentPurchase() {

        let encriptedCardId = "";

        for (var i = 0; i < 10; i++) {

            if (i == 6) {
                encriptedCardId += "," + this.selectedCreditCardId;                
            } else if (i == 8) {
                encriptedCardId += "," + this.selectedCreditCard.cvc;
            } else {
                encriptedCardId += "," + this.randomNum();
            }
        }

        encriptedCardId = encriptedCardId.substr(1);
        console.log('encriptedCardId', encriptedCardId);

        let purchase = new AssessmentPurchaseDto();
        purchase.CoachId = this._Globals.getUserId();
        purchase.TotalAmount = Math.round(((this.total - (this.total * this.totalDiscount / 100)) + Number.EPSILON) * 100) / 100;
        purchase.AssignedId = this._Globals.getUserId();
        purchase.EncriptedCardId = this._CryptoJs.encrypt(encriptedCardId, '7s6v9y$8&3)H@McKfT8WnZqWt7w!B@C*');
        purchase.Details = this.assessmentDetails;

        //console.log(purchase);
        //return; 

        this._AdminService.postPurchaseProcess(purchase).subscribe(data => {
            console.log('response_postPurchaseProcess', data);
            switch (data.result.Result) {
                case -6:
                    this.toastr.error('We are sorry. An error happened while verifying the credit card info.', 'ELI');
                    break;
                case -5:
                    this.toastr.error('CVV code does not match.', 'ELI');
                    break;
                case -4:
                    this.toastr.error(`We are sorry. Credit card could not be charged because of the following situation: ${data.result.Data}`, 'ELI');
                    break;
                case -3:
                    this.toastr.error('We are sorry. An error happened when trying to complete the purchase process. Details could not be added to the invoice.', 'ELI');
                    break;
                case -2:
                    this.toastr.error('We are sorry. An error happened when trying to complete the purchase process. Invoice could not be created.', 'ELI');
                    break;
                case -1:
                    this.toastr.error('We are sorry. An error happened when trying to complete the purchase process.  User not found.', 'ELI');
                    break;
                case 0:
                    this.toastr.error('We are sorry. An unexpected error happened when trying to complete the purchase process.','ELI');
                    break;
            }

            

            if (this.coachCreaditCards.length > 0) {
                let selectedCard = $("#cardNumber").prop('selectedIndex');
                this.getCoachCreditCards(false, selectedCard);
                //this.selectedCreditCardId = this.coachCreaditCards[0].Id;
                //this.selectedCreditCard.cardUserName = this.coachCreaditCards[0].NameOnCard;
            }

            if (data.result.Result > 0) {
                this.toastr.success('Assessment purchase completed successfully', 'ELI');
                //pages close actions
                if (this.parent) {
                    console.log('PAGE NAME', this.parent.pageName);

                    switch (this.parent.pageName) {
                        case "coach_assessments":
                            $('.desktopTabs li').click();
                            break;

                        case "clients":
                            break;

                        case "edit_clients":
                            $('.desktopTabs li.active').first().click();
                            break;

                        case "home":
                            this.parent.getCoachDashboardInfo();
                            break;

                        default:
                            console.log("NO PAGE");
                    }
                }

                this.closeModal();
                this.close();

                this.selectedCreditCard = {
                    cardNumber: "", //5555555555554444
                    cardUserName: "",
                    cardType: "",
                    expiryMonth: "1",
                    expiryYear: `${this.year}`,
                    cvc: "",
                    address1: "",
                    address2: "",
                    city: "",
                    state: "",
                    zipCode: "",
                    country: "United States",
                    phone: "",
                    email: ""
                }
            }

            $('body').css('cursor', 'default');
            this.loading = false;

        });
    }

    getAssessmentsByNiche(niche: number, event?: any) {
        if (event != undefined) { 
            this.currentNicheOrDefault = event.target.selectedOptions["0"].innerText;
        }
        console.log(this.currentNicheOrDefault);
        console.log(this.currentTypeOrDefault);

        this._AdminService.getAssessmentsByNiche(niche).subscribe((data: any) => {
            console.log(`Assessments by niche: ${niche}`, this.assessments);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.assessments = _data;
            } 
        });
    }

    setAssessmentType(event: any) {
        console.log(event);
        this.currentTypeOrDefault = event.target.selectedOptions["0"].innerText;
        console.log(this.currentTypeOrDefault);
    }

    getClientDiscount() {
        this._ClientService.getClientDiscount().subscribe((data: any) => {
            console.log('response getClientDiscount', data);
            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result === 0)
                { 
                    this.showDiscountModal();
                } else {
                    this.discounts = JSON.parse(this._CryptoJs.decrypt(data.result.Data, 'M86v70$B&E!H@MlKfTj9nZ34tPw!z%8*'));
                    if (this.discounts.length > 0) {
                        this.discounts.forEach((discount) => {
                            this.totalDiscount += discount.DiscountPercent;
                        });
                    }
                    console.log('discount', this.discounts);
                    console.log('total discount', this.totalDiscount);
                    this.displayPurchaseAssessmentModal();
                }                
            } 
        });
    }

    displayPurchaseAssessmentModal() {
        this.hideDiscountModal();
        let type = 1;

        if (!isUndefined(this.parent.assessmentType)) {
            this.showATCombo = false;
            if (this.parent.assessmentType == 1 || this.parent.assessmentType == 0.1 || this._Globals.assessmentsTypeFlag == 0) {
                type = 1;
            } else {
                type = 2;
            }
        } else {
            //open from home
            this.showATCombo = true;
        }

        this.modal.show();
        this.orders = [];
        this.getAssessmentsbyType(false);
        this.getAssessmentsbyType(true);
        $('#niches option').eq(0).prop('selected', true);
        $('#assessmentType option').eq(0).prop('selected', true);
        $('#purchaseAssessmentSelect option').eq(0).prop('selected', true);
        $('#quantity').val('1');
        this.total = 0;

        this.selectedCreditCard.expiryMonth = "01";
        this.selectedCreditCard.expiryYear = this.year.toString();
        this.selectedCreditCard.cvc = "";

        this.getCoachCreditCards(false);
        this.addingNewCreditCard = false;

        console.log(creditcardvalidator);
    }

    show(parent: any): void {
        console.log('show modal');
        this.getClientDiscount();

        this.parent = parent;
    }

    onShown(): void {
    }

    close(): void {
        this.modal.hide();
        this.purchaseAssessments = true;
        this.questionIndex = 0;
        this.askingQuestions = false;
        this.finishPurchase = false;
        this.assessmentDetails = [];
        this.total = 0;
        this.totalDiscount = 0;
    }

    calculateTotal(quantity:number, is360: boolean) {
        let price = 0;
        let pricings;

        if (!is360) {
            pricings = this.eliAssessment[0].Pricing;
        } else {
            pricings = this.assessment360[0].Pricing;
        }

        pricings.forEach((pricing) => {
            //console.log(pricing);
            if(quantity >= pricing.RangeStart) {
                if (pricing.RangeEnd == 0) {
                    price = pricing.Price;
                } else if(quantity <= pricing.RangeEnd) {
                    price = pricing.Price;
                }
                
            }
        });

        return quantity * price;
    }

    addOrder(is360: boolean, quantity: any) {
        //validate
        if (quantity === "" || Number(quantity) <= 0) {
            this.toastr.warning('Please enter a valid quantity.', 'ELI');

            let input: any; 
            if (!is360) {
                input = $('#quantity');
            } else {
                input = $('#quantity360');
            }

            input.focus();
            input.css('box-shadow', '0px 0px 15px 3px #4d9fd5');
            input.css('-webkit-box-shadow', '0px 0px 15px 3px #4d9fd5');

            setTimeout(() => {
                input.css('box-shadow', 'none');
                input.css('-webkit-box-shadow', 'none');
            }, 2000);


            return;
        }

        //Reset values
        let values;
        if (!is360) {
            values = this.eliAssessment[0];
            $('#quantity').val(1);
        } else {
            values = this.assessment360[0];
            $('#quantity360').val(1);
        }

        quantity = parseInt(quantity);
        let assessmentId = values.Id;
        let version = values.MajorVersion + "." + values.MinorVersion;
        let name = values.Name;

        if (version == '') {
            this.toastr.warning('No Assessment selected', 'ELI');
            return
        }

        let order = {};
        //check if exist
        let detailPos = this.assessmentDetails.map(function (e) { return e.X2; }).indexOf(parseInt(assessmentId));
        if (detailPos == -1) {

            //adding details
            let details = new AssessmentPurchaseDetails();
            details.X2 = parseInt(assessmentId);
            details.X5 = parseInt(quantity);
            details.X9 = this.calculateTotal(quantity, is360);
            this.assessmentDetails.push(details);

            order = {
                "Id": assessmentId,
                "Name": name,
                "Niche": `${this.currentNicheOrDefault} (${this.currentTypeOrDefault})`,
                "Version": version,
                "Quantity": details.X5,
                "Total": `$${details.X9}`
            }
            console.log('order to add', order);

        } else {
            this.assessmentDetails[detailPos].X5 = this.assessmentDetails[detailPos].X5 + parseInt(quantity);
            this.assessmentDetails[detailPos].X9 = this.calculateTotal(this.assessmentDetails[detailPos].X5, is360);

            order = {
                "Id": assessmentId,
                "Name": name,
                "Niche": `${this.currentNicheOrDefault} (${this.currentTypeOrDefault})`,
                "Version": version,
                "Quantity": this.assessmentDetails[detailPos].X5,
                "Total": `$${this.assessmentDetails[detailPos].X9}`
            }
            console.log('order to add', order);

        }
        console.log('assessmentDetails', this.assessmentDetails);




        /*let currentNiche = `${this.currentNicheOrDefault} (${this.currentTypeOrDefault})`;
        let currentAssessment = newOrder.Name;
        let currentVersion = version;*/

        let versionPos = this.orders.map(function (e) { return e.Id; }).indexOf(assessmentId);
        if (versionPos != -1) {
            console.log('updating values');
            let oldValues = this.orders[versionPos];
            let oldAmount = this.calculateTotal(this.orders[versionPos].Quantity, is360);
            let newAmount = this.assessmentDetails[detailPos].X9;
            let oldTotal = parseInt(oldValues.Total.match(/\d/g).join(""));
            let newTotal = oldTotal - oldAmount + newAmount;

            this.orders[versionPos].Quantity = this.assessmentDetails[detailPos].X5;
            this.orders[versionPos].Total = "$"+newTotal;

            var model = this.gridApi.getModel();
            var rowNode = model.rowsToDisplay[versionPos];
            rowNode.setDataValue("Quantity", this.assessmentDetails[detailPos].X5);
            rowNode.setDataValue("Total", `$${newTotal}`);
            this.total = this.total - oldTotal + newTotal;

        } else {
            this.orders.push(order);
            var res = this.gridApi.updateRowData({ add: [order] });
            this.total += this.calculateTotal(quantity, is360);
        }

        //check if the current assessment name exist
        //let namePos = this.orders.map(function (e) { return e.Name; }).indexOf(currentAssessment);
        //if (namePos == -1) {
        //    //add new order
        //    this.orders.push(newOrder);
        //    var res = this.gridApi.updateRowData({ add: [newOrder] });
        //    this.total += total;

        //} else {

        //    //check if the current assessment niche exist
        //    let nichePos = this.orders.map(function (e) { return e.Niche; }).indexOf(currentNiche);
        //    if (nichePos == -1) {
        //        //add new order
        //        this.orders.push(newOrder);
        //        var res = this.gridApi.updateRowData({ add: [newOrder] });
        //        this.total += total;

        //    } else {

        //        ////check if the current assessment Version exist
        //        let versionPos = this.orders.map(function (e) { return e.Version; }).indexOf(currentVersion);
        //        if (versionPos != -1) {
        //            console.log('updating values');
        //            let oldValues = this.orders[versionPos];
        //            let newQuantity = parseInt(oldValues.Quantity) + parseInt(quantity);
        //            let oldTotal = parseInt(oldValues.Total.match(/\d/g).join(""));
        //            let newTotal = oldTotal + total;

        //            this.orders[versionPos].Quantity = newQuantity;
        //            this.orders[versionPos].Total = newTotal;

        //            var model = this.gridApi.getModel();
        //            var rowNode = model.rowsToDisplay[versionPos];
        //            rowNode.setDataValue("Quantity", newQuantity);
        //            rowNode.setDataValue("Total", `$${newTotal}`);
        //            this.total = this.total - oldTotal + newTotal;

        //        } else {
        //            this.orders.push(newOrder);
        //            var res = this.gridApi.updateRowData({ add: [newOrder] });
        //            this.total += total;
        //        }



        //    }
        //}
        
        console.log('orders', this.orders);

        this.sizeToFit(this.gridApi);

    }

    //---------------------------
    //--------ag-grid-----------
    //---------------------------

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi) {
        this.gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.sizeToFit(this.gridApi);
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    createHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 150,
            width: 150,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        //let nicheHeader = {
        //    headerName: 'Niche',
        //    field: 'Niche',
        //    minWidth: 150,
        //    width: 150,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(nicheHeader);

        //let versionHeader = {
        //    headerName: 'Version',
        //    field: 'Version',
        //    minWidth: 90,
        //    width: 90,
        //    suppressSizeToFit: true,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(versionHeader);

        let quantityHeader = {
            headerName: 'Quantity',
            field: 'Quantity',
            minWidth: 110,
            width: 110,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(quantityHeader);

        let totalHeader = {
            headerName: 'Total',
            field: 'Total',
            minWidth: 110,
            width: 110,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(totalHeader);

        let actionsHeader = {
            headerName: '',
            field: '',
            width: 50,
            minWidth: 50,
            suppressSizeToFit: true,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                let content = '';

                content += '<i id="deleteOrder" title="Delete Order" class="material-icons custom-icons" style="color: #2199c7;">cancel</i>';

                return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

            }
        };
        columnDefs.push(actionsHeader);

        return columnDefs;
    }

    public onRowClicked(e) {
        console.log(e);
        let rowIndex = e.rowIndex;
        if (e.event.target !== undefined) {
            let data = e.data;
            switch (e.event.target.id) {
                //case "editAction":
                //    {
                //        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                //        this.edit(data['Id'], data['Text']);
                //        break;
                //    }

                //case "deleteAction":
                //    {
                //        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                //        this.delete();
                //        break;
                //    }
                case "deleteOrder": {
                    console.log('deleteOrder');
                    this.deleteOrder(rowIndex);
                    break;
                }
            }
        }
    }

    deleteOrder(rowIndex: number) {
        var model = this.gridApi.getModel();
        model.rowsToDisplay.splice(rowIndex, 1);
        console.log('question to delete', this.orders[rowIndex]);

        let toSubtract = this.orders[rowIndex].Total.substring(1);
        this.orders.splice(rowIndex, 1);
        this.assessmentDetails.splice(rowIndex, 1);

        this.total += - parseInt(toSubtract);

        //var selectedData = this.gridApi.getSelectedRows();
        //var res = this.gridApi.updateRowData({ remove: this.orders[rowIndex] });
        //console.log(res);

        let items = this.orders;
        this.orders = [];
        setTimeout(() => {
            this.orders = items;
            console.log('orders', this.orders);
            this.gridApi.redrawRows();
        }, 0);
    }

    openModal() {
        console.log('open modal');
        if (this.total != 0) {
            console.log('Total', Math.round(((this.total - (this.total * this.totalDiscount / 100)) + Number.EPSILON) * 100) / 100);
            this.message = "";

            $("#formModal").modal({ backdrop: "static" });
            $('#formModal').modal('show');

            //this.setICreditCardIcon(this.selectedCreditCard.cardType);

        } else {
            this.toastr.warning('Please add at least one assessment to the order.','ELI');
        }
    }

    showDiscountModal() {
        $("#discountModal").modal({ backdrop: "static" });
        $('#discountModal').modal('show');
    }

    hideDiscountModal() {
        $('#discountModal').modal('hide');
    }

    closeModal() {
        $('#formModal').modal('hide');
    }

    validateNumber(evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode == 8) return true;
        if ((charCode > 95 || charCode < 106)) return true;
        if ((charCode < 48 || charCode > 57)) return false;

        return true;
    }

    preventFirst0(id: string) {
       const inputText = String($('#' + id).val());
        // var charCode = evt.keyCode;
        // console.log(charCode);
        //if ((charCode > 31 && (charCode < 48 || charCode > 57)) || (parseInt(evt.target.value) <= 0)) {
            //if (charCode < 96 || charCode > 105 || (parseInt(evt.target.value) <= 0)) {
        if (parseInt(inputText) <= 0 || inputText == "") {
                $('#' + id).val(1);
                return false;
            } else {
                return true;
            }
        //}else {
        //    return true;
        //}
        
    }

    getCoachCreditCards(selectLastest:boolean, cardIndex?:any) {
        console.log('Getting coach credit cars');
        this._CoachService.getCoachCreditCards().subscribe((data: any) => {
            console.log('getCoachCreditCards_response', data.result);
            if (this._Globals.validationToken(data.result.Result)) {
                this.coachCreaditCards = JSON.parse(this._CryptoJs.decrypt(JSON.parse(data.result.Data), '3s6v9y$B&3)H@McQfT4WnZqWt7w!z%C*'));

                if (this.coachCreaditCards.length > 0 && !selectLastest) {
                    this.selectedCreditCardId = this.coachCreaditCards[0].Id;
                    this.selectedCreditCard.cardUserName = this.coachCreaditCards[0].NameOnCard;
                    this.selectedCreditCard.cardType = this.coachCreaditCards[0].CardType;
                    this.selectedCreditCard.expiryMonth = this.coachCreaditCards[0].ExpirationMonth;
                    this.selectedCreditCard.expiryYear = this.coachCreaditCards[0].ExpirationYear;

                    this.selectedCreditCard.address1 = this.coachCreaditCards[0].BillAddress1;
                    this.selectedCreditCard.address2 = this.coachCreaditCards[0].BillAddress2;
                    this.selectedCreditCard.city = this.coachCreaditCards[0].BillCity;
                    this.selectedCreditCard.state = this.coachCreaditCards[0].BillState;
                    this.selectedCreditCard.zipCode = this.coachCreaditCards[0].BillZip;
                    this.selectedCreditCard.country = (this.coachCreaditCards[0].BillCountry == "") ? "United States" : this.coachCreaditCards[0].BillCountry;
                    this.selectedCreditCard.phone = this.coachCreaditCards[0].BillPhoneNumber;
                    this.selectedCreditCard.email = this.coachCreaditCards[0].BillEmail;
                   
                } else if (selectLastest) {
                    this.selectedCreditCardId = this.coachCreaditCards[this.coachCreaditCards.length - 1].Id;
                    this.selectedCreditCard.cardUserName = this.coachCreaditCards[this.coachCreaditCards.length - 1].NameOnCard;
                    this.selectedCreditCard.cardType = this.coachCreaditCards[this.coachCreaditCards.length - 1].CardType;
                    this.selectedCreditCard.expiryMonth = this.coachCreaditCards[this.coachCreaditCards.length - 1].ExpirationMonth;
                    this.selectedCreditCard.expiryYear = this.coachCreaditCards[this.coachCreaditCards.length - 1].ExpirationYear; 

                    this.selectedCreditCard.address1 = this.coachCreaditCards[this.coachCreaditCards.length - 1].BillAddress1;
                    this.selectedCreditCard.address2 = this.coachCreaditCards[this.coachCreaditCards.length - 1].BillAddress2;
                    this.selectedCreditCard.city = this.coachCreaditCards[this.coachCreaditCards.length - 1].BillCity;
                    this.selectedCreditCard.state = this.coachCreaditCards[this.coachCreaditCards.length - 1].BillState;
                    this.selectedCreditCard.zipCode = this.coachCreaditCards[this.coachCreaditCards.length - 1].BillZip;
                    this.selectedCreditCard.country = (this.coachCreaditCards[this.coachCreaditCards.length - 1].BillCountry == "") ? "United States" : this.coachCreaditCards[this.coachCreaditCards.length - 1].BillCountry;
                    this.selectedCreditCard.phone = this.coachCreaditCards[this.coachCreaditCards.length - 1].BillPhoneNumber;
                    this.selectedCreditCard.email = this.coachCreaditCards[this.coachCreaditCards.length - 1].BillEmail;

                }

                this.setICreditCardIcon(this.selectedCreditCard.cardType);
                console.log(this.coachCreaditCards);    

                if (cardIndex != undefined) {
                    this.getCreditCardDataByIndex(cardIndex, this.selectedCreditCard.cvc);
                }
            }
        });
    }

    changeCreditCard(e:any) {
        console.log(this.coachCreaditCards[e.target.selectedIndex]);
        this.getCreditCardDataByIndex(e.target.selectedIndex);
    }

    getCreditCardDataByIndex(index, tempCvv?) {
        this.selectedCreditCardId = this.coachCreaditCards[index].Id;
        this.selectedCreditCard.cardNumber = this.coachCreaditCards[index].Last4Digits;
        this.selectedCreditCard.cardUserName = this.coachCreaditCards[index].NameOnCard;
        this.selectedCreditCard.cardType = this.coachCreaditCards[index].CardType;
        this.selectedCreditCard.expiryMonth = this.coachCreaditCards[index].ExpirationMonth;
        this.selectedCreditCard.expiryYear = this.coachCreaditCards[index].ExpirationYear;
        this.selectedCreditCard.cvc = tempCvv != isUndefined ? tempCvv : ""; 

        this.selectedCreditCard.address1 = this.coachCreaditCards[index].BillAddress1;
        this.selectedCreditCard.address2 = this.coachCreaditCards[index].BillAddress2;
        this.selectedCreditCard.city = this.coachCreaditCards[index].BillCity;
        this.selectedCreditCard.state = this.coachCreaditCards[index].BillState;
        this.selectedCreditCard.zipCode = this.coachCreaditCards[index].BillZip;
        this.selectedCreditCard.country = (this.coachCreaditCards[index].BillCountry == "") ? "United States" : this.coachCreaditCards[index].BillCountry;
        this.selectedCreditCard.phone = this.coachCreaditCards[index].BillPhoneNumber;
        this.selectedCreditCard.email = this.coachCreaditCards[index].BillEmail;

        console.log(this.selectedCreditCard.cardType);
        this.setICreditCardIcon(this.selectedCreditCard.cardType);
    }

    setICreditCardIcon(cardType) {
        switch (cardType) {
            case 'visa':
                $('#cardIcon').css('background-position', '0px -56px');
                break;
            case 'Mastercard':
                $('#cardIcon').css('background-position', '0px -169px');
                break;
            case 'AMEX':
                $('#cardIcon').css('background-position', '0px -338px');
                break;
            case 'Discover':
                $('#cardIcon').css('background-position', '0px -283px');
                break;
            default:
                $('#cardIcon').css('background-position', '0px 0px');
        }
    }

    addNewCard() {
        console.log('add new card');
        this.addingNewCreditCard = true;
    }

    createRange(number) {
        var items: number[] = [];
        for (var i = 1; i <= number; i++) {
            items.push(i);
        }
        return items;
    }

    validateCard() {
        $('#newCardNumber').validateCreditCard((result)=> {
            console.log(result);

            let cardinput = $('#newCardNumber');

            if (result.card_type != null) {
                switch (result.card_type.name) {
                    case "visa":
                        //$('#newCardType').val('Visa');
                        this.newCreditCard.type = "Visa";
                        cardinput.css('background-position', '3px -34px');
                        cardinput.addClass('card_visa');
                        break;

                    case "visa_electron":
                        //$('#newCardType').val('Visa Electron');
                        this.newCreditCard.type = "Visa Electron";
                        cardinput.css('background-position', '3px -72px');
                        cardinput.addClass('card_visa_electron');
                        break;

                    case "mastercard":
                        //$('#newCardType').val('Mastercard');
                        this.newCreditCard.type = "Mastercard";
                        cardinput.css('background-position', '3px -110px');
                        cardinput.addClass('card_mastercard');
                        break;

                    case "maestro":
                        //$('#newCardType').val('Maestro');
                        this.newCreditCard.type = "Maestro";
                        cardinput.css('background-position', '3px -148px');
                        cardinput.addClass('card_maestro');
                        break;

                    case "discover":
                        //$('#newCardType').val('Discover');
                        this.newCreditCard.type = "Discover";
                        cardinput.css('background-position', '3px -186px');
                        cardinput.addClass('card_discover');
                        break;

                    case "amex":
                        //$('#newCardType').val('AMEX');
                        this.newCreditCard.type = "AMEX";
                        cardinput.css('background-position', '3px -223px');
                        cardinput.addClass('card_amex');
                        break;

                    default:
                        cardinput.css('background-position', '3px 3px');
                        break;
                }
            } else {
                cardinput.css('background-position', '3px 3px');
                //$('#newCardType').val('');
                this.newCreditCard.type = "";

            }

            // Check for valid card numbere - only show validation checks for invalid Luhn when length is correct so as not to confuse user as they type.
            if (result.length_valid || cardinput.val().length > 16) {
                if (result.luhn_valid) {
                    //cardinput.parent().removeClass('has-error').addClass('has-success');
                    $('#newCardNumber').css({
                        "border": "1px solid #ccc",
                        "border-color": "#2b542c",
                        "outline": "0",
                        "-webkit-box-shadow": "inset 0 1px 1px rgba(0,0,0,.075), 0 0 6px #67b168",
                        "box-shadow": "inset 0 1px 1px rgba(0,0,0,.075), 0 0 6px #67b168"
                    });
                    this.validCreditCard = true;
                } else {
                    //cardinput.parent().removeClass('has-success').addClass('has-error');
                    $('#newCardNumber').css({
                        "border": "1px solid #ccc",
                        "border-color": "#843534",
                        "outline": "0",
                        "-webkit-box-shadow": "inset 0 1px 1px rgba(0,0,0,.075), 0 0 6px #ce8483",
                        "box-shadow": "inset 0 1px 1px rgba(0,0,0,.075), 0 0 6px #ce8483"
                    });
                    this.validCreditCard = false;
                }
            } else {
                //cardinput.parent().removeClass('has-success').removeClass('has-error');
                $('#newCardNumber').css({
                    "border": "1px solid #ccc",
                    "border-color": "#ccc",
                    "outline": "0",
                    "-webkit-box-shadow": "none",
                    "box-shadow": "none"
                });
                this.validCreditCard = false;
            }
        });

        $('#newCardNumber').unbind();

    }

    generateJsonData() {
        console.log(this.newCreditCard);
        let data = {
            "Id": this._Globals.getUserId(),
            "Last4Digits": this.newCreditCard.number,
            "NameOnCard": this.newCreditCard.name,
            "ExpirationMonth": parseInt(this.newCreditCard.month),
            "ExpirationYear": parseInt(this.newCreditCard.year),
            "CardType": this.newCreditCard.type,
            "CVV": this.newCreditCard.cvc
        }
        this.addNewCreditCard(JSON.stringify(data));
    }

    addNewCreditCard(jsonData: string) {
        this._CoachService.postAddNewCreditCard(this._CryptoJs.encrypt(jsonData, '8s6v9y$8&3)H@McQfT8WnZqWt7w!A%C*')).subscribe((data: any) => {
            console.log('addNewCreditCard_response', data.result);
            if (this._Globals.validationToken(data.result.Result)) {
                

                if (data.result.Result > 1) {
                    this.selectedCreditCard.cvc = this.newCreditCard.cvc;
                    this.clearNewCreditCardData();
                    this.toastr.success("Credit Card added successfully.", "ELI");
                    this.getCoachCreditCards(true);
                } else {
                    switch (data.result.Result) {
                        //case -3:
                        //    this.toastr.error("The provided credit card info is not valid.", "ELI");
                        //    break;
                        case -2:
                            this.toastr.error("The provided credit card info is not valid.", "ELI");
                            break;
                        case -1:
                            this.toastr.error("There is already a credit card on file with the same provided info.", "ELI");
                            break;
                        default:
                            this.toastr.error("We are sorry. An error happened while trying to add the credit card to your file.", "ELI");
                            break;
                    }
                }
            }
        });

    }

    clearNewCreditCardData(): void {
        this.addingNewCreditCard = false;
        this.validCreditCard = false;

        this.newCreditCard.number = "";
        this.newCreditCard.name = "";
        this.newCreditCard.type = "";
        this.newCreditCard.month = "1";
        this.newCreditCard.year = `${this.year}`;
        this.newCreditCard.cvc = "";
    }

    preventSpace(value: string, event: any) {
        let tagName = event.target.id;

        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $('#' + tagName).val('');
        }
    }

    preventLetters(event: any) {
        if (event.which < 48 || event.which > 57) {
            event.preventDefault();
            console.log('');
        }
    }

}

